//----------------------
// calc knowledge bonus
//----------------------
export default function calcKnowBonus(int) {
  // console.log('---------------------------------')
  // console.log('IN calcKnowBonus')

  const this_int = Number(int) || 0

  // console.log('this_int = ', this_int)

  const kb = this_int - 10
  return kb
}
